// Значения — 1:1 с LocalStorageKeys из старого проекта (types/localStorage.ts). Это не просто
// внутреннее имя: SuperApp сам пишет токены в localStorage под этими ключами при открытии
// WebView (напрямую, без cookie) — если имя не совпадает, наш фронт токен просто не увидит.
export enum StorageKey {
  AccessToken = 'accessToken',
  RefreshToken = 'refreshToken',
  IsWebview = 'isWebView',
  AppVersion = 'appVersion',
}
